export default class JobCardsFixedCta {
    constructor () {
        this.cta = document.querySelectorAll('.jobcards__fixed-cta')
        this.visibilityClass = 'jobcards__fixed-cta--visible'

        if (!this.cta)
            return

        this.cta.forEach(cta => this.observeVisibility(cta))
    }

    observeVisibility (el) {
        const sectionSelector = el.querySelector('a').getAttribute('href')
        const listing = document.querySelector(sectionSelector)

        if (listing) {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0
            }

            const callback = (changes) => {
                changes.forEach((change) => {
                    if (change.intersectionRatio > 0)
                        el.classList.remove(this.visibilityClass)
                    else
                        el.classList.add(this.visibilityClass)
                })
            }

            const observer = new IntersectionObserver(callback, options) // eslint-disable-line no-undef
            observer.observe(listing)
        }
    }
}
